import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { Logger, LogManager } from '../../utils/logger/logger';
import { AddToBlacklistRequest } from '../api/blacklist/addtoblacklist/addtoblacklistrequest';
import { AddToBlacklistResponse, AddToBlacklistResponseDtoImpl } from '../api/blacklist/addtoblacklist/addtoblacklistresponse';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { SixdeeCRBTAPIProcessor } from './sixdeecrbtapiprocessor';
import { Strings } from '../../utils/resources/strings';

export class AddToBlacklistAPIProcessorImpl extends SixdeeCRBTAPIProcessor<AddToBlacklistRequest, AddToBlacklistResponse>
{
    private LOGGER: Logger = LogManager.getLogger(AddToBlacklistAPIProcessorImpl.name);
    execute(request: AddToBlacklistRequest): void {
        super.execute(request);
    }

    onSuccess(responseMapper: ResponseMapper): void 
    {
        this.LOGGER.log("onSuccess() invoked");

        super.onSuccess(responseMapper);
        try {

            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS) {

                let response = new AddToBlacklistResponseDtoImpl(APIFeatures.ADD_TO_BLACKLIST, "Add To Blacklist Success");

                this.getAPISuccess(response);
            }
        }
        catch (e) {
            this.getAPIFailure(new AddToBlacklistResponseDtoImpl(APIFeatures.ADD_TO_BLACKLIST, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
        super.onFailure(responseMapper);

       this.getAPIFailure(new AddToBlacklistResponseDtoImpl(APIFeatures.ADD_TO_BLACKLIST, responseMapper.getStatusMsg()));
        
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/addtoblacklistapiprocessor.tsx